import { render, staticRenderFns } from "./CountDownDesempate.vue?vue&type=template&id=3120db70&scoped=true"
import script from "./CountDownDesempate.vue?vue&type=script&lang=js"
export * from "./CountDownDesempate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120db70",
  null
  
)

export default component.exports